import { faFileCsv } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import { AgGridReact } from 'ag-grid-react'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button, Card, CardHeader, Col, Row } from 'reactstrap'
import './styles/UsersManagement.css'
import './styles/styles.css'

import { useLocation } from 'react-router'

import CardHeaderButton from 'components/Custom/CardHeaderButton'
import { fetchGroups } from 'store/Group/actions'
import {
  deleteUser,
  fetchRoles,
  fetchStores,
  fetchUsersExtendedDetails,
  fetchUsersExtendedDetailsCount,
  fetchUsersExtendedDetailsCountWithFilters,
  fetchUsersExtendedDetailsWithFilters,
  onClickExportButton,
  proxyIntoUser,
  resetUsersExtendedDetails,
  setAccessFilter,
  setActiveFilters,
  setArchivedFilter,
  setEmailFilter,
  setExternalIdFilter,
  setExtraField1Filter,
  setExtraField2Filter,
  setFirstNameFilter,
  setHasActiveFilters,
  setLastLoginFilter,
  setLastNameFilter,
  setLocationGroupsFilter,
  setRolesFilter,
  setStatusFilter,
  setStoresFilter,
  setUserColumnData,
  setUsernameFilter,
  setUserRowData,
} from 'store/Users/actions'
import {
  formatAdminColumns,
  formatAreaAdminColumns,
  formatCourseManagerColumns,
  formatRows,
} from './FilterConfig'

// Global Css Leon
import '../../../assets/css/Global/style.css'

// Custom Css Leon
import WelcomeEmailModal from './WelcomeEmailModal'
import './styles/UserList.css'
import { setLastPathname } from 'store/Course/actions'

const UserList = (props) => {
  const dispatch = useDispatch()

  const location = useLocation()
  useEffect(() => {
    dispatch(setLastPathname(location.pathname))
  }, [])

  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  const user = useSelector((state) => state.auth.user)
  const users = useSelector((state) => state.users)
  const groups = useSelector((state) => state.groups)
  const stores = useSelector((state) => state.stores)
  const [gridApi, setGridApi] = useState({})
  const [params, setParamas] = useState({})
  const [timer, setTimer] = useState(null)
  const [showSendWelcomeModal, setShowSendWelcomeModal] = useState(false)

  const [rowClassRules, setRowClassRules] = useState({
    'archived-rule': (params) => params.data.archived === 'Yes',
    'loa-rule': (params) => params.data.status === 'Leave of Absence',
    'termed-rule': (params) => params.data.status === 'Term',
  })

  // Make sure these colors are the same as legend colors
  const getRowStyle = (params) => {
    if (params.data.archived === 'Yes') {
      return { background: 'rgba(226, 81, 90, 0.3)' }
    }
    if (params.data.status === 'Term') {
      return { background: 'rgba(255, 69, 0, 0.1)' }
    }
    if (params.data.status === 'Leave of Absence') {
      return { background: 'rgba(194, 186, 83, 0.2)' }
    }
    return null
  }

  const MyExportCSV = (props) => {
    return (
      <button
        className='btn btn-info wFull'
        onClick={() => dispatch(onClickExportButton())}
      >
        <FontAwesomeIcon icon={faFileCsv} />
      </button>
    )
  }

  const setFormatedColumns = (usersExtendedDetails, language) => {
    // let language = null
    // language.language
    //   ? (language = language.language.data)
    //   : null;
    if (usersExtendedDetails.length) {
      dispatch(
        setUserRowData(
          formatRows(
            usersExtendedDetails,
            users.access,
            users.is_proxied,
            language
          )
        )
      )

      const extraColumns = ['extra_field_1', 'extra_field_2']
      const columns = formatAdminColumns(
        usersExtendedDetails,
        users.id,
        users.stores,
        language
      ).filter(
        (item) => !extraColumns.includes(item.field)
        // (item) =>
        //   !extraColumns.includes(item.field) ||
        //   (courseConfig.enableUserExtraFields &&
        //     parseInt(courseConfig.enableUserExtraFields) === 1)
      )
      users.access === 1 || users.access === 3 || users.access === 2
        ? dispatch(setUserColumnData(columns))
        : users.access === 4 || users.access === 5
        ? dispatch(
            setUserColumnData(
              formatAreaAdminColumns(usersExtendedDetails, language)
            )
          )
        : dispatch(
            setUserColumnData(
              formatCourseManagerColumns(
                usersExtendedDetails,
                language
                // (courseConfig.userCourseManagerCanEditUser = 1)
              )
            )
          )
    } else {
      dispatch(setUserRowData([]))
    }
  }

  const [hasScrollbar, setHasScrollbar] = useState(false)

  const handleFirstDataRendered = (params) => {
    const gridApi = params.api

    const isVerticalScrollbarVisible =
      gridApi.getVerticalPixelRange().bottom >
      gridApi.getVerticalPixelRange().clientHeight

    setHasScrollbar(isVerticalScrollbarVisible)
  }
  const onGridReady = (params) => {
    setGridApi(params.api)
    setParamas(params)
  }

  const onCellClicked = (params) => {
    switch (params.value) {
      case 'Delete':
        return dispatch(deleteUser(params.data.id))
      case 'Proxy':
        if (params.data.id !== user.id) {
          return dispatch(proxyIntoUser(params.data.id))
        }
        return
      default:
        return
    }
  }

  useEffect(() => {
    dispatch(fetchStores())
    dispatch(fetchGroups())
    dispatch(fetchRoles())

    dispatch(resetUsersExtendedDetails())
    if (users.hasActiveFilters) {
      dispatch(fetchUsersExtendedDetailsCountWithFilters(users.activeFilters))
      dispatch(fetchUsersExtendedDetailsWithFilters(users.activeFilters))
    } else {
      dispatch(fetchUsersExtendedDetailsCount())
      dispatch(fetchUsersExtendedDetails())
    }
  }, [users.hasActiveFilters, users.activeFilters, dispatch])

  useEffect(() => {
    setFormatedColumns(users.usersExtendedDetails, language)
  }, [users.usersExtendedDetails])

  useEffect(() => {
    if (
      users.firstNameFilter ||
      users.lastNameFilter ||
      users.extraField1Filter ||
      users.extraField2Filter ||
      users.lastLoginFilter ||
      users.emailFilter ||
      users.usernameFilter ||
      users.externalIdFilter ||
      users.rolesFilter.length ||
      users.accessFilter.length ||
      users.storesFilter.length ||
      users.statusFilter.length ||
      users.locationGroupsFilter.length ||
      users.archivedFilter
    ) {
      dispatch(setHasActiveFilters(true))
    } else {
      dispatch(setHasActiveFilters(false))
    }
    const activeFilters = {}

    if (users.firstNameFilter) {
      activeFilters['first_name'] = {
        filter: 'firstNameFilter',
        label: 'first_name',
        name: 'first name',
        value: users.firstNameFilter,
      }
    }

    if (users.lastNameFilter) {
      activeFilters['last_name'] = {
        filter: 'lastNameFilter',
        label: 'last_name',
        name: 'last name',
        value: users.lastNameFilter,
      }
    }
    if (users.extraField1Filter) {
      activeFilters['extra_field_1'] = {
        filter: 'extraField1Filter',
        label: 'extra_field_1',
        name: 'extra_field_1',
        value: users.extraField1Filter,
      }
    }
    if (users.extraField2Filter) {
      activeFilters['extra_field_2'] = {
        filter: 'extraField2Filter',
        label: 'extra_field_2',
        name: 'Extra_field_2',
        value: users.extraField2Filter,
      }
    }
    if (users.lastLoginFilter) {
      activeFilters['last_login'] = {
        filter: 'lastLoginFilter',
        label: 'last_login',
        name: 'Last_login',
        value: users.lastLoginFilter,
      }
    }
    if (users.emailFilter) {
      activeFilters['email'] = {
        filter: 'emailFilter',
        label: 'email',
        name: 'email',
        value: users.emailFilter,
      }
    }
    if (users.usernameFilter) {
      activeFilters['username'] = {
        filter: 'usernameFilter',
        label: 'username',
        name: 'username',
        value: users.usernameFilter,
      }
    }
    if (users.externalIdFilter) {
      activeFilters['external_id'] = {
        filter: 'externalIdFilter',
        label: 'external_id',
        name: 'employee id',
        value: users.externalIdFilter,
      }
    }
    if (users.rolesFilter.length) {
      activeFilters['role'] = {
        filter: 'rolesFilter',
        label: 'role',
        name: 'role',
        value: users.rolesFilter.map((item) => item.name).toString(),
      }
    }
    if (users.accessFilter.length) {
      activeFilters['access'] = {
        filter: 'accessFilter',
        label: 'access',
        name: 'access',
        value: users.accessFilter.map((item) => item.option.access).toString(),
      }
    }
    if (users.storesFilter.length) {
      activeFilters['store'] = {
        filter: 'storesFilter',
        label: 'store',
        name: 'location',
        value: users.storesFilter.map((item) => item.option.id).toString(),
      }
    }
    if (users.locationGroupsFilter.length) {
      activeFilters['group'] = {
        filter: 'locationGroupsFilter',
        label: 'group',
        name: 'location group',
        value: users.locationGroupsFilter
          .map((item) => item.option.id)
          .toString(),
      }
    }
    if (users.statusFilter.length) {
      activeFilters['status'] = {
        filter: 'statusFilter',
        label: 'status',
        name: 'status',
        value: users.statusFilter,
      }
    }
    if (users.archivedFilter) {
      activeFilters['archived'] = {
        filter: 'archivedFilter',
        label: 'archived',
        name: 'archived',
        value: users.archivedFilter,
      }
    }

    setTimer(
      setTimeout(() => {
        dispatch(setActiveFilters(activeFilters))
      }, 800)
    )

    return () => clearTimeout(timer)
  }, [
    users.firstNameFilter,
    users.lastNameFilter,
    users.extraField1Filter,
    users.extraField2Filter,
    users.lastLoginFilter,
    users.emailFilter,
    users.usernameFilter,
    users.externalIdFilter,
    users.rolesFilter.length,
    users.accessFilter.length,
    users.storesFilter.length,
    users.statusFilter.length,
    users.locationGroupsFilter.length,
    users.archivedFilter,
  ])
  return (
    <Card className='shadow-none'>
      <div className=''>
        {/* <div ref={ref}> */}
        <Col className='px-0'>
          <CardHeader className='pl-3 pb-4 pt-0 border-bottom-0'>
            {/* <Row className='leon'>
              <div className='leon col8 md-col12 wFull gap1 pl-1 pb-2'>
                <Link
                  to={`/settings/users/new`}
                  className='col3 xl-col4 md-col12 wFull'
                >
                  <CardHeaderButton className='wFull' text='Add User' />
                </Link>
                <Link
                  to={`/settings/users/import`}
                  className='col3 xl-col4 md-col12 wFull'
                >
                  <CardHeaderButton className='wFull' text='Import User' />
                </Link>
                <button
                  title={`Export to .csv`}
                  className='col2 xl-col2 md-col12 wFull btn btn-download'
                  onClick={() => dispatch(onClickExportButton())}
                >
                  <FontAwesomeIcon icon={faFileCsv} size={'2x'} />
                </button>
              </div>

              <div className='col4 md-col12 leon pb-3'>
                <div className='leon col12'> */}
            {/* Remove small filter name to show */}
            {/* <div className='col11 filter-label-holder'>
                    {Object.keys(users.activeFilters).length ? (
                      <ul>
                        {Object.values(users.activeFilters).map(
                          (item, index) => (
                            <li
                              onClick={() =>
                                dispatch(
                                  removeSingleFilter(item.filter, item.label)
                                )
                              }
                              // style={{
                              //   display: 'inline-flex',
                              //   alignItems: 'center',
                              // }}
                              key={index}
                            >
                              <FontAwesomeIcon
                                icon={faTimesCircle}
                                // style={{ height: "15px" }}
                                className='filter-label-icon'
                              />
                              {item.name}
                            </li>
                          )
                        )}
                      </ul>
                    ) : null}
                  </div> */}
            {/* <Button
                    type='button'
                    className={`col1 btn btn-info btn-clear-filters  ${
                      users.hasActiveFilters ? 'btn-danger' : 'btn-disabled'
                    }`}
                    disabled={users.hasActiveFilters ? false : true}
                    onClick={() => dispatch(setHasActiveFilters(false))}
                  >
                    {language.settings ? language.settings.clear_filters : null}
                  </Button>
                </div>
              </div>
            </Row> */}
            <div className='row mb-3'>
              <div className='btn-container col-md-9 px-0 '>
                <Link to={`/settings/users/new`} >
                  <CardHeaderButton
                    text={language.settings ? language.settings.add_user : null}
                    className="user-management-btn"
                  />
                </Link>
                <Link to={`/settings/users/import`} >
                  <CardHeaderButton text='Import User' className="user-management-btn"/>
                </Link>
                <CardHeaderButton
                  text='Send Email'
                  customFn={() => setShowSendWelcomeModal(true)}
                  className="user-management-btn"
                />

                <WelcomeEmailModal
                  userAccess={user?.access}
                  showSendWelcomeModal={showSendWelcomeModal}
                  setShowSendWelcomeModal={setShowSendWelcomeModal}
                  users={users}
                />

                <button
                  title={`Export to .csv`}
                  className='p-1 btn btn-download csv-btn user-management-btn'
                  onClick={() => dispatch(onClickExportButton())}
                >
                  <FontAwesomeIcon icon={faFileCsv} size={'2x'} />
                </button>
              </div>

              <div className='col-md-3 px-0 d-flex justify-content-md-end justify-content-start align-items-center mt-md-0 mt-2'>
                <Button
                  type='button'
                  className={`col1 btn btn-info btn-clear-filters ${
                    users.hasActiveFilters ? 'btn-danger' : 'btn-disabled'
                  }`}
                  disabled={users.hasActiveFilters ? false : true}
                  onClick={() => dispatch(setHasActiveFilters(false))}
                >
                  {language.settings ? language.settings.clear_filters : null}
                </Button>
              </div>
            </div>
            <Row>
              <Col className='pl-1 mt-3'>
                <span>
                  <span className='legend-rectangle archived-legend'></span>
                  <span className='legend-text'> Archived</span>
                </span>
                <span className='ml-3'>
                  <span className='legend-rectangle termed-legend'></span>
                  <span className='legend-text'> Terminated</span>
                </span>
                <span className='ml-3'>
                  <span className='legend-rectangle loa-legend'></span>
                  <span className='legend-text'>LOA</span>
                </span>
              </Col>
            </Row>
          </CardHeader>
        </Col>
        {console.log('leart512', users.usersRowData)}

        <div className='ag-theme-alpine user-list_container pl-0 pr-0'>
          <AgGridReact
            onGridReady={onGridReady}
            columnDefs={users.usersColumnData}
            // animateRows={true}
            onFirstDataRendered={handleFirstDataRendered}
            headerClass={hasScrollbar ? 'custom-header' : ''}
            pagination={true}
            rowBuffer={20}
            paginationPageSize={50}
            suppressColumnVirtualisation={true}
            suppressRowVirtualisation={true}
            enableBrowserTooltips={true}
            onCellClicked={onCellClicked}
            getRowStyle={getRowStyle}
            context={{
              setFirstNameFilter: (e) => dispatch(setFirstNameFilter(e)),
              setLastNameFilter: (e) => dispatch(setLastNameFilter(e)),
              setExtraField1Filter: (e) => dispatch(setExtraField1Filter(e)),
              setExtraField2Filter: (e) => dispatch(setExtraField2Filter(e)),
              setLastLoginFilter: (e) => dispatch(setLastLoginFilter(e)),
              setEmailFilter: (e) => dispatch(setEmailFilter(e)),
              setUsernameFilter: (e) => dispatch(setUsernameFilter(e)),
              setRolesFilter: (e) => dispatch(setRolesFilter(e)),
              setAccessFilter: (e) => dispatch(setAccessFilter(e)),
              setStoresFilter: (e) => dispatch(setStoresFilter(e)),
              setStatusFilter: (...args) => dispatch(setStatusFilter(...args)),
              setLocationGroupsFilter: (e) =>
                dispatch(setLocationGroupsFilter(e)),
              setExternalIdFilter: (e) => dispatch(setExternalIdFilter(e)),
              setArchivedFilter: (...args) =>
                dispatch(setArchivedFilter(...args)),
              allRoles: users.allRoles,
              allStores: stores.allStores,
              allLocationGroups: groups.locationGroups,
              showArchivedUsers: users.showArchivedUsers,
              showTerminatedUsers: users.showTerminatedUsers,
              ...users,
            }}
            rowData={users.usersRowData}
            rowClassRules={rowClassRules}
          ></AgGridReact>
        </div>
      </div>
    </Card>
  )
}

export default UserList
